import styled from "styled-components"

const EventsFilters = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const BorderTaxo = styled.span`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  color: ${(props) =>
    props.activeBool ? props.activeText : props.theme.b_color_gradients.b_dark};
  background-color: ${(props) =>
    props.activeBool ? props.theme.b_color_gradients.b_dark : props.activeText};
  &:hover {
    background-color: ${(props) =>
      props.activeBool ? null : props.theme.b_color_gradients.b_dark};
    color: ${(props) => (props.activeBool ? null : props.activeText)};
  }
`

const EventsItem = styled.div`
  &:not(:last-child) {
    border-bottom: 5px solid ${(props) => props.theme.a_color_gradients.a_light};
  }
`

const EventsPeriodFilter = styled.p`
  color: ${(props) =>
    props.active === true
      ? props.theme.b_color_gradients.b_dark
      : props.theme.d_color_gradients.d_dark};
`

const EventsPeriodFilterContainer = styled.div`
  border-right: 2px solid ${(props) => props.theme.a_color_gradients.a_light};
  @media (max-width: 900px) {
    border-bottom: 2px solid ${(props) => props.theme.a_color_gradients.a_light};
  }
`

export {
  EventsFilters,
  EventsItem,
  BorderTaxo,
  EventsPeriodFilter,
  EventsPeriodFilterContainer,
}
